<template>
  <div>
    <li class="bg-white shadow-md p-4 overflow-hidden rounded-lg border border-balternative-color">
      <a
        class="flex flex-wrap flex-row md:flex-col lg:flex-row items-center text-decoration-none justify-center md:justify-center lg:justify-start text-center md:text-center lg:text-left md:space-x-0 md:space-y-2 lg:space-x-2 lg:space-y-0"
        href=""
        @click.prevent="goToBaseProductDetailPage"
      >
        <div class="flex items-center lg:justify-start text-left min-h-20 min-w-20">
          <img :src="baseProduct.imageUrl" @error="handleImageError" class="max-h-20 max-w-20 mx-auto" />
        </div>

        <div class="flex flex-col flex-grow w-full md:w-auto lg:w-1/3 md:text-center lg:text-left">
          <strong class="text-gray-800 font-normal text-lg leading-6">{{ $toTitleCase(baseProduct.title) }}</strong>
          <strong class="text-gray-600 font-normal text-sm leading-normal">{{
            $toTitleCase(baseProduct.manufName)
          }}</strong>
        </div>

        <div class="grid mx-auto mt-4 md:mt-0">
          <button
            v-if="!baseProduct.isExpanded"
            @click.prevent="toggle"
            class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full ml-auto text-nowrap"
          >
            <span>{{ buttonTextOptions.more }}</span>
          </button>

          <button
            v-else
            @click.prevent="toggle"
            class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full ml-auto text-nowrap"
          >
            <span>{{ buttonTextOptions.less }}</span>
          </button>
        </div>
      </a>
      <div v-if="baseProductDetail" v-show="baseProduct.isExpanded" class="mt-2">
        <div
          class="flex flex-col gap-2 mb-4"
          v-if="baseProductDetail.products && baseProductDetail.products.length > 0"
        >
          <card
            v-for="item in baseProductDetail.products"
            :key="item.productId"
            class="border border-disabled-background h-full flex flex-col relative"
          >
            <template v-slot>
              <div class="absolute top-2 right-2" @click.prevent="favorite(item, baseProductDetail)">
                <component
                  :is="item.isFavourite ? 'HeartSolidIcon' : 'HeartIcon'"
                  class="h-5 w-5 text-primary-default cursor-pointer"
                />
              </div>
              <div class="flex flex-col md:flex-row flex-grow gap-2">
                <div class="flex-col">
                  <div class="md:text-base text-xs text-tdefault-color font-bold mb-2 cursor-pointer overflow-hidden">
                    {{ $toTitleCase(item.title) }}
                  </div>
                  <div class="flex-row mb-2">
                    <span class="text-tdefault-color md:text-base text-xs mr-2">{{ item.productCode }}</span>
                    <span class="text-tdefault-color md:text-base text-xs pl-2 border-l border-stone-200">
                      {{ item.packagingUnit }} {{ item.packagingLabel }}
                    </span>
                  </div>
                  <div class="row">
                    <div class="mb-2">
                      <span
                        v-if="isCustomerFlow"
                        class="inline-flex gap-1 border-b border-dashed md:text-base text-xs"
                        :class="
                          item.isInsured
                            ? 'text-success-default border-success-default'
                            : 'text-danger-text border-danger-text'
                        "
                      >
                        <component
                          :is="item.isInsured ? 'CheckCircleIcon' : 'ExclamationCircleIcon'"
                          class="h-4 w-4 md:h-5 md:w-5"
                        />
                        {{ item.isInsured ? 'Vergoed' : 'Niet vergoed' }}
                      </span>
                    </div>
                    <div class="md:ml-5 mb-2 hidden">
                      <span
                        class="inline-flex gap-1 border-b border-dashed md:text-base text-xs"
                        :class="item.orderable ? '' : 'text-warning-default border-warning-default'"
                      >
                        <component :is="item.orderable ? '' : 'XCircleIcon'" class="h-4 w-4 md:h-5 md:w-5" />
                        {{ item.orderable ? '' : 'Niet leverbaar' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="grid mx-auto mt-4 md:mt-0 content-center relative md:absolute md:right-2 self-center">
                  <button
                    v-if="isFavoriteSelectedFlow(item.productRelationType) && !item.orderable && !isAssortmentFlow"
                    class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
                    @click.prevent="
                      showAlternateProducts(item.alternativeProductModel, item.productRelationType, item.isFavourite)
                    "
                  >
                    {{ getButtonText(item.productRelationType) }}
                  </button>

                  <button
                    v-else-if="
                      isProductDetailsPageFlow(item.isAlternativesBPIdAvailable) && !item.orderable && !isAssortmentFlow
                    "
                    class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
                    @click.prevent="goToAlternativesProductDetailsPage(item.alternativesBaseProductId)"
                  >
                    {{ getButtonText(item.productRelationType) }}
                  </button>

                  <button
                    v-else-if="item.orderable && !isAssortmentFlow"
                    class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
                    @click.prevent="order(item.productId, 1)"
                  >
                    Bestellen
                  </button>
                  <div class="mb-2 md:mr-2" v-else-if="String(item.MaterialStatusCode) === '30' && !isAssortmentFlow">
                    Op bestelling verkrijgbaar
                  </div>
                  <div class="mb-2 md:mr-2" v-else-if="!item.orderable && !isAssortmentFlow">Niet bestelbaar</div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </li>
    <div
      v-if="isPrompt"
      class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="relative z-40 text-left p-8 bg-white w-full max-w-lg box-border rounded-lg">
        <h3 class="float-right cursor-pointer text-lg" @click="closeOverlay()">X</h3>
        <div class="w-115">
          <div class="grid grid-cols-1 gap-4">
            <div class="text-lg text-cyan-600 font-light">Product valt niet binnen de machtiging(en).</div>
            <div class="text-base text-gray-800">
              Zonder machtiging ontvangt de patiënt geen vergoeding van de zorgverzekeraar. Weet u zeker dat u wilt
              doorgaan?
            </div>
            <div class="flex justify-between">
              <v-button class="border-none mt-1 text-cyan-500" @click.prevent="continueAddProduct">
                Toch bestellen
              </v-button>
              <router-link
                to="/patientdashboard"
                class="btn btn--secondary text-white bg-teal-900 rounded-md px-4 py-2"
              >
                Machtiging aanmaken
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed top-0 left-0 w-full h-full" @click="closeOverlay()" />
    </div>
    <v-overlay v-if="showProductFavourites">
      <v-product-favourites
        :base-product="selectedBaseProductForFavorite"
        :product="selectedProductForFavorite"
        :product-id="productId"
        @success="successSaveFavorite(...arguments)"
        @cancel="closeFavOverlay"
      />
    </v-overlay>
    <!--Pop up to show alternative products -->
    <generic-modal
      v-if="showAlternateProductPopUp"
      :has-close-button="true"
      :modal-Medium-Width="true"
      @close="closeAlternateProductModal"
    >
      <template #header>
        <div v-if="productRelationType == 'Followup'" class="mb-4">Opvolgend product</div>
        <div v-if="productRelationType == 'Substitute'" class="mb-4">Vervangend product</div>
        <div v-else-if="productRelationType == 'Alternatives'" class="mb-4">Alternatief product</div>
      </template>
      <template #body>
        <div class="mb-4">
          <Alert :html="true" :htmlMessage="alternativeProductHtmlMsg" type="info"></Alert>
        </div>
        <div class="relative mb-4">
          <div class="grid sm:grid-rows-4 md:grid-cols-2 lg:grid-cols-2 gap-2 mb-4">
            <card
              v-for="item in alternateCards"
              :key="item.id"
              class="border border-disabled-background h-full flex flex-col"
              :class="[item.isOriginalProduct ? 'bg-primary-product' : '']"
            >
              <template v-slot>
                <div class="flex flex-col flex-grow -mt-6">
                  <div
                    class="flex items-center justify-center my-2 h-28 w-full flex-shrink-0 cursor-pointer"
                    @click.prevent="goToProductDetailPage(item.baseProductId, item.isOriginalProduct)"
                  >
                    <img
                      :src="getImageUrl(item.imageUrl)"
                      @error="handleImageError"
                      class="mx-auto max-h-full max-w-full"
                    />
                  </div>
                  <div
                    class="text-tdefault-color font-semibold text-xs mb-1 h-14 overflow-hidden cursor-pointer"
                    @click.prevent="goToProductDetailPage(item.baseProductId, item.isOriginalProduct)"
                  >
                    {{ item.name }}
                  </div>
                  <div class="text-talternative-color text-sm mb-4">{{ item.packagingDetails }}</div>
                </div>
                <div class="mt-auto">
                  <div class="grid grid-cols-2 gap-2 mb-3">
                    <div class="flex items-center text-sm">
                      <span
                        class="inline-flex items-center gap-1 border-b border-dashed px-1"
                        :class="item.orderable ? '' : 'text-warning-default border-warning-default'"
                      >
                        <component :is="item.orderable ? '' : 'XCircleIcon'" class="h-5 w-5" />
                        {{ item.orderable ? '' : 'Niet leverbaar' }}
                      </span>
                    </div>
                    <div class="flex items-center text-sm">
                      <span
                        class="inline-flex items-center gap-1 border-b border-dashed px-1"
                        :class="
                          item.insured
                            ? 'text-success-default border-success-default'
                            : 'text-danger-text border-danger-text'
                        "
                      >
                        <component :is="item.insured ? 'CheckCircleIcon' : 'ExclamationCircleIcon'" class="h-5 w-5" />
                        {{ item.insured ? 'Vergoed' : 'Niet vergoed' }}
                      </span>
                    </div>
                  </div>

                  <div class="grid grid-cols-1">
                    <div class="flex items-center text-sm">
                      <button
                        v-if="!item.isOriginalProduct && item.orderable && itemIsFavourite"
                        class="flex justify-center pl-5 pr-5 text-white text-xs md:text-base font-medium items-center bg-primary-default border border-primary-default rounded-full p-2"
                        @click.prevent="switchFavoriet(item.productId, item.originalProductId)"
                      >
                        Vervang favoriet
                      </button>
                      <button
                        v-else-if="!item.isOriginalProduct && item.orderable"
                        class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
                        @click.prevent="favouriteFlowOrder(item, 1)"
                      >
                        Bestellen
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </card>
          </div>
          <div
            class="hidden absolute w-full top-32 z-50"
            v-if="recentAlternateProducts.length != 0 && alternateCards.length > 0"
          >
            <div
              class="flex mb-4"
              :class="[
                (showAlternateNext && showAlternatePrev) || (showAlternatePrev && !showAlternateNext)
                  ? 'justify-between items-center'
                  : 'justify-end'
              ]"
            >
              <button
                v-if="showAlternatePrev"
                @click="alternatePrev"
                :class="{ hidden: alternateSlideIndex === 0 }"
                class="rounded-full bg-primary-default border border-primary-default -ml-4"
              >
                <ChevronLeftIcon class="h-8 w-8 inline-block text-white" aria-hidden="true" />
              </button>
              <button
                v-if="showAlternateNext"
                @click="alternateNext"
                :class="{ hidden: alternateSlideIndex + alternatesPerPage >= recentAlternateProducts.length }"
                class="rounded-full bg-primary-default border border-primary-default -mr-4"
              >
                <ChevronRightIcon class="h-8 w-3 w-8 inline-block text-white" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </template>
      <template #footer> </template>
    </generic-modal>
  </div>
</template>

<script>
import axios from 'axios';
import router from '@/router';
import VProductVariants from './productDetail/ProductVariants';
import { computed, ref, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon, HeartIcon } from '@heroicons/vue/24/outline';
import { HeartIcon as HeartSolidIcon } from '@heroicons/vue/20/solid';
import VProductFavourites from './productDetail/ProductFavourites';
import GenericModal from '@/components/shared/GenericModal';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/vue/20/solid';

import {
  shoppingCart$,
  addToShoppingCart,
  currentUserIdentity$,
  activePpwRecId$,
  getReplenishmentBaseProductDetail,
  getBaseProductDetails
} from '@/services';

export default {
  name: 'VProduct',
  components: {
    VProductVariants,
    CheckCircleIcon,
    ExclamationCircleIcon,
    XCircleIcon,
    HeartIcon,
    HeartSolidIcon,
    VProductFavourites,
    GenericModal,
    ChevronRightIcon,
    ChevronLeftIcon
  },
  props: {
    baseProduct: {
      type: Object,
      required: true
    },
    favoriteSelected: {
      type: Boolean,
      default: false
    },
    favoriteBundleIds: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const shoppingCart = ref(null);
    const user = ref(null);
    const activePpwRecId = ref(null);
    const showProductFavourites = ref(false);
    const productId = ref(null);
    const selectedProductForFavorite = ref({});
    const selectedBaseProductForFavorite = ref({});

    const overlayActive = computed(() => store.getters['catalog/getOverlay']);
    const setOrderClicked = (value) => store.commit('cart/setOrderClicked', value);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    currentUserIdentity$.subscribe((value) => {
      user.value = value;
    });

    activePpwRecId$.subscribe((value) => {
      activePpwRecId.value = value;
    });

    const favorite = (product, baseProduct) => {
      selectedProductForFavorite.value = product;
      selectedBaseProductForFavorite.value = baseProduct;
      productId.value = product.productId;
      showProductFavourites.value = true;
    };
    const closeFavOverlay = () => {
      showProductFavourites.value = false;
    };

    const successSaveFavorite = () => {
      selectedProductForFavorite.value = null;
      selectedBaseProductForFavorite.value = null;
      productId.value = null;
      closeFavOverlay();
      proxy.computeBaseProductDetails();
    };

    return {
      overlayActive,
      setOrderClicked,
      shoppingCart,
      user,
      activePpwRecId,
      favorite,
      successSaveFavorite,
      closeFavOverlay,
      showProductFavourites,
      selectedBaseProductForFavorite,
      selectedProductForFavorite,
      productId
    };
  },
  data() {
    return {
      baseProductDetail: null,
      isExpanded: false,
      buttonTextOptions: {
        more: 'Toon meer',
        less: 'Toon minder'
      },
      isPrompt: false,
      currentOrderDetails: {},
      showAlternateProductPopUp: false,
      productRelationType: '',
      alternativeProductHtmlMsg:
        '<b>Onze product specialisten raden dit alternatieve product aan </b> </br> Dit product is niet te bestellen. Onze product specialisten hebben voor u een alternatief product geselecteerd.',
      recentAlternateProducts: null,
      alternatePages: 0,
      alternatesPerPage: 2,
      alternateCards: null,
      alternateSlideIndex: 0,
      showAlternatePrev: false,
      showAlternateNext: false,
      itemIsFavourite: false
    };
  },
  computed: {
    isReplenishmentFlow() {
      return router.currentRoute.value.meta.flow === 'replenishment';
    },
    isAssortmentFlow() {
      return router.currentRoute.value.meta.flow === 'assortment';
    },
    isCustomerFlow() {
      return router.currentRoute.value.meta.flow === 'customer';
    },
    isFavoriteSelectedFlow() {
      return (alternativeProductModel) => {
        return this.favoriteSelected && alternativeProductModel !== null;
      };
    },
    isProductDetailsPageFlow() {
      return (isAlternativesBPIdAvailable) => {
        return isAlternativesBPIdAvailable;
      };
    }
  },
  watch: {
    baseProductDetail(value) {
      if (
        value &&
        value.products &&
        value.products.length === 0 &&
        this.baseProduct.baseProductId === value.baseProductId
      ) {
        this.goToBaseProductDetailPage();
      }
    },
    overlayActive(value) {
      if (value) {
        this.baseProduct.isExpanded = false;
        this.baseProductDetail = null;
      }
    }
  },
  methods: {
    goToBaseProductDetailPage() {
      if (this.isCustomerFlow) {
        router.push('/catalog/baseProduct/' + this.baseProduct.baseProductId);
      }
      if (this.isReplenishmentFlow) {
        router.push('/aanvullenmagazijn/baseProduct/' + this.baseProduct.baseProductId);
      }
      if (this.isAssortmentFlow) {
        router.push('/assortiment/baseProduct/' + this.baseProduct.baseProductId);
      }
    },
    toggle(e) {
      e.stopPropagation();
      this.baseProduct.isExpanded = !this.baseProduct.isExpanded;
      if (this.baseProduct.isExpanded && !this.baseProductDetail) {
        this.computeBaseProductDetails();
      }
    },
    computeBaseProductDetails() {
      // fetch and assign product detail
      (this.isReplenishmentFlow
        ? getReplenishmentBaseProductDetail(this.baseProduct.baseProductId)
        : getBaseProductDetails(this.baseProduct.baseProductId, this.isCustomerFlow)
      ).then((response) => {
        this.baseProductDetail = response;
        this.gtmDataForViewProduct();
      });
    },
    gtmDataForViewProduct() {
      let products = [];
      if (this.baseProductDetail && this.baseProductDetail.products.length > 0) {
        this.baseProductDetail.products.forEach((product) => {
          products.push({
            item_id: product.productId,
            item_name: product.title,
            item_brand: this.baseProductDetail.manufName,
            quantity: 1
          });
        });

        window.dataLayer.push({
          event: 'view_item_list',
          ecommerce: {
            item_list_name: router.currentRoute.value.path,
            items: products
          }
        });
      }
    },
    showAlert(productId) {
      const orderedProduct = this.baseProductDetail.products.find((p) => p.productId === productId);

      if (orderedProduct) {
        this.$emitter.emit('notification', {
          title: `${orderedProduct.title} is toegevoegd.`,
          htmlMessage: `<p class="underline cursor text-gray-900" data-route="/bestellijst">Bestelling afronden</p>`
        });
      }
    },
    favoriteFlowShowAlert(item) {
      this.$emitter.emit('notification', {
        title: `${item.title} is toegevoegd.`,
        htmlMessage: `<p class="underline cursor text-gray-900" data-route="/bestellijst">Bestelling afronden</p>`
      });
    },
    favouriteFlowOrder(item, count) {
      if (item.isInsured == undefined || item.isInsured == null) isInsured = false;

      let order = this.baseProductDetail;
      this.showAlternateProductPopUp = false;
      order.isInsured = item.isInsured;
      order.addedToBasket = true;
      order.count = count;
      addToShoppingCart(this.shoppingCart, item.productId, count, this.activePpwRecId, item.isConsignmentProduct);
      this.favoriteFlowShowAlert(item);
    },
    // Function to add product to the cart
    order(productId, count) {
      this.setOrderClicked(true);
      let order = this.baseProductDetail;
      if (order) {
        let isInsuredProd =
          this.baseProductDetail.products.filter((x) => x.productId === productId && x.isInsured === true).length > 0;
        let isConsignmentProduct =
          this.baseProductDetail.products.filter((x) => x.productId === productId && x.isConsignmentProduct === true)
            .length > 0;
        if (!isInsuredProd && this.isCustomerFlow) {
          this.isPrompt = true;
          this.currentOrderDetails = {
            productId: productId,
            amount: count,
            isConsignmentProduct: isConsignmentProduct
          };
        } else {
          this.isPrompt = false;
          order.isInsured = isInsuredProd;
          order.addedToBasket = true;
          order.count = count;
          addToShoppingCart(this.shoppingCart, productId, count, this.activePpwRecId, isConsignmentProduct);
          this.showAlert(productId);
        }
      }
    },
    continueAddProduct() {
      this.setOrderClicked(true);
      this.isPrompt = false;
      addToShoppingCart(
        this.shoppingCart,
        this.currentOrderDetails.productId,
        this.currentOrderDetails.amount,
        this.activePpwRecId,
        this.currentOrderDetails.isConsignmentProduct
      );
      this.showAlert(this.currentOrderDetails.productId);
      this.currentOrderDetails = {};
    },
    closeOverlay() {
      this.isPrompt = false;
    },
    loadSearch() {
      this.$emit('reloadSearch');
    },
    showAlternateProducts(alternativeProductModel, type, isFavourite) {
      this.productRelationType = type;
      this.itemIsFavourite = isFavourite;
      if (type === 'Followup') {
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatieve', 'opvolgende');
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatief', 'opvolgend');
      } else if (type === 'Substitute') {
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatieve', 'vervangende');
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatief', 'vervangend');
      }

      this.recentAlternateProducts = computed(() => {
        const computedAlternateProducts = Array.isArray(alternativeProductModel) ? alternativeProductModel : [];
        const firstProduct = computedAlternateProducts[0]?.ProductId;

        const result = computedAlternateProducts.map((item) => ({
          ...item,
          showLabel: item.ProductId === firstProduct
        }));
        // Slice if filterCount is present
        return result;
      });

      this.alternatePages = computed(() => {
        return Math.ceil(this.recentAlternateProducts.length / this.alternatesPerPage);
      });

      this.alternateCards = computed(() => {
        let start = this.alternateSlideIndex * this.alternatesPerPage;
        let end = start + this.alternatesPerPage;
        if (start > this.recentAlternateProducts?.length) {
          this.resetAlternateIndex();
          start = 0;
          end = 2;
        }
        return this.recentAlternateProducts ? this.recentAlternateProducts.slice(start, end) : [];
      });

      this.showAlternatePrev = computed(() => this.alternateSlideIndex > 0);
      this.showAlternateNext = computed(() => this.alternateSlideIndex < this.alternatePages - 1);

      this.showAlternateProductPopUp = true;
    },
    alternateNext() {
      if (this.alternateSlideIndex < this.alternatePages - 1) {
        this.alternateSlideIndex++;
      }
    },
    alternatePrev() {
      if (this.alternateSlideIndex > 0) {
        this.alternateSlideIndex--;
      }
    },
    resetAlternateIndex() {
      this.alternateSlideIndex = 0;
    },
    closeAlternateProductModal() {
      this.showAlternateProductPopUp = false;
      this.alternateSlideIndex = 0;
    },
    switchFavoriet(newProductId, oldProductId) {
      axios
        .post('FavouriteProduct/SwitchProductInFavouriteList', {
          bundleIds: this.favoriteBundleIds,
          newProductId: newProductId,
          oldProductId: oldProductId
        })
        .then((response) => {
          if (response && response.data) {
            this.closeAlternateProductModal();
            this.loadSearch();
          }
        });
    },
    goToAlternativesProductDetailsPage(baseProductId) {
      if (baseProductId) {
        router.push('/catalog/baseProduct/' + baseProductId);
      }
    },
    getButtonText(productRelationType) {
      switch (productRelationType) {
        case 'Followup':
          return 'Bekijk opvolgende';
        case 'Substitute':
          return 'Bekijk vervangende';
        case 'Alternatives':
          return 'Bekijk alternatief';
        default:
      }
    },
    goToProductDetailPage(baseProductId, flag) {
      router.push('/catalog/baseProduct/' + baseProductId);
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-primary-product {
  background-color: #dee2e6 !important;
}
</style>
